const green = {
  10: '#D3EEE7',
  50: '#91D5C4',
  100: '#67C4AC',
  200: '#2BAB89',
}

export default green
